import ArticleNewsletterExportList from './article-newsletter-export-list';

export default ArticleNewsletterExportList;
